import { Component, OnInit, Input, Inject, ViewContainerRef } from '@angular/core';
import {
  InspectionObservationPointsViewModel,
  QuestionModelComingFrom,
  ObservationQuestionsViewModel,
  PhotoModelComingFrom,
} from '../../../../inspection.model';
import { DomSanitizer } from '@angular/platform-browser';
import { NewInspectionService } from '../../../../inpsection.service';
import { LoadingService } from '../../../../../../../shared/services/loading.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-observation-questions',
  templateUrl: './observation-questions.component.html',
  styleUrls: ['./observation-questions.component.scss']
})
export class ObservationQuestionsComponent implements OnInit {


  ObservationPoint: InspectionObservationPointsViewModel;

  savingChanges = false;
  comingFrom: QuestionModelComingFrom;


  photoModelEntryPoint: PhotoModelComingFrom;

  constructor(
    private _dialogRef: MatDialogRef<ObservationQuestionsComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _sanitizer: DomSanitizer,
    private _inspectionService: NewInspectionService,
    private _loadingService: LoadingService,
    private _toster: ToastrService, vr: ViewContainerRef
  ) {
    //this._toster.setRootViewContainerRef(vr);
   }

  ngOnInit() {
    if (this._data.comingFrom) {
      this.comingFrom = this._data.comingFrom;
      this.ObservationPoint = this._data.observation;
      switch (this.comingFrom) {
        case QuestionModelComingFrom.NewInspection:
          this.photoModelEntryPoint = PhotoModelComingFrom.NewInspectionQuestionImages;
          break;
        case QuestionModelComingFrom.Interpretation:
          this.photoModelEntryPoint = PhotoModelComingFrom.InterpretationQuestionImages;
          break;
        default:
          break;
      }
    }


    console.log('questionModel ' + this.ObservationPoint);
  }


  saveChanges() {

   if (this.comingFrom) {
     switch (this.comingFrom) {
      case QuestionModelComingFrom.Interpretation:
        this._inspectionService.ChangedObservationLevelQuestionAnswers(this.ObservationPoint)
        .subscribe(r => {
          this._toster.success('Successfully updated observations');
          this._dialogRef.close(true);
        });
      break;
      case QuestionModelComingFrom.NewInspection:
      this.onCloseClick();
      break;
      default: break;
     }
   }
  }

  onCloseClick() {
    this._dialogRef.close();
  }

  Checked(question: ObservationQuestionsViewModel) {
    question.Checked = !question.Checked;
  }



  getImage(image: string) {
    if (image != null && image !== undefined) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    }
  }
}
